import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ReportsComponent } from './components/reports/reports.component';


const reportsRoutes: Routes = [
    { path: '', component: ReportsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(reportsRoutes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
                                                                                                                                                                                                                                                                                                                                                                      